import React from "react";
import Alert from '@material-ui/lab/Alert';

function Home(props) {
var styles = {
    "textAlign":"center"
}

    return (
        <div>
            {/*<h1 style={styles}><p><b><span>Welcome to the Self Service Portal!</span></b></p></h1>*/}
            <Alert severity="error">
                It seems like you're trying to access our portal in a way that's not usual. Please make sure you're clicking on the exact link we've sent you or reach out to our service provider for assistance.
            </Alert>
        </div>
    );
}

export default Home;
